import { render } from "./WeekComponent.vue?vue&type=template&id=349b38ac"
import script from "./WeekComponent.vue?vue&type=script&lang=js"
export * from "./WeekComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__